/**
 * react-router-dom v6 route table.
 *
 * /                      → role-based redirect
 * /login                 → public
 * /student               → student home (assignments list)
 * /student/assignments/:assignmentId/submit → upload
 * /student/submissions/:submissionId        → grading result
 * /teacher               → teacher dashboard
 * /teacher/students      → student CRUD
 * /teacher/problems      → problem CRUD
 */
import { useEffect } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { useAuth } from './stores/auth';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './routes/login/Login';
import { StudentHome } from './routes/student/StudentHome';
import { AssignmentSubmit } from './routes/student/AssignmentSubmit';
import { SubmissionResult } from './routes/student/SubmissionResult';
import { TeacherHome } from './routes/teacher/TeacherHome';
import { StudentList } from './routes/teacher/StudentList';
import { ProblemList } from './routes/teacher/ProblemList';

function RoleRedirect() {
  const { user, initialized, refresh } = useAuth();

  useEffect(() => {
    if (!initialized) {
      void refresh();
    }
  }, [initialized, refresh]);

  if (!initialized) return <div style={{ padding: 24 }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === 'admin' ? '/teacher' : '/student'} replace />;
}

export const router = createBrowserRouter([
  { path: '/', element: <RoleRedirect /> },
  { path: '/login', element: <Login /> },

  // Student routes
  {
    path: '/student',
    element: (
      <ProtectedRoute role="student">
        <StudentHome />
      </ProtectedRoute>
    ),
  },
  {
    path: '/student/assignments/:assignmentId/submit',
    element: (
      <ProtectedRoute role="student">
        <AssignmentSubmit />
      </ProtectedRoute>
    ),
  },
  {
    path: '/student/submissions/:submissionId',
    element: (
      <ProtectedRoute role="student">
        <SubmissionResult />
      </ProtectedRoute>
    ),
  },

  // Teacher routes
  {
    path: '/teacher',
    element: (
      <ProtectedRoute role="admin">
        <TeacherHome />
      </ProtectedRoute>
    ),
  },
  {
    path: '/teacher/students',
    element: (
      <ProtectedRoute role="admin">
        <StudentList />
      </ProtectedRoute>
    ),
  },
  {
    path: '/teacher/problems',
    element: (
      <ProtectedRoute role="admin">
        <ProblemList />
      </ProtectedRoute>
    ),
  },

  { path: '*', element: <Navigate to="/" replace /> },
]);
